// extracted by mini-css-extract-plugin
export default {"moreInfoHeader":"styles_moreInfoHeader__awR6Z","nodeInfo":"styles_nodeInfo__BAISa"};